<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-17 10:51:54
 * @LastEditTime: 2019-08-17 10:52:35
 * @LastEditors: Please set LastEditors
 -->
<template>
    <el-dialog
            title="选择经销商/门店"
            :visible="true"
            width="85%"
            :append-to-body=true
            :before-close="handleClose">
        <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
            <el-tab-pane label="选择经销商" name="first">
                <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
                    <el-form-item label="经销商编号:">
                        <el-input v-model="form.dealer_sn" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="经销商名称:">
                        <el-input v-model="form.dealer_name" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="关键词:">
                        <el-input v-model="form.keywords" clearable placeholder="手机号、负责人"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getDealer()">搜索</el-button>
                    </el-form-item>
                </el-form>
                <span>提示：经销商资料请【客户】-【经销商管理】中添加、管理</span>
                <!--表格-->
                <el-table
                        ref="multipleTable"
                        :data="tableData1"
                        v-loading="loading"
                        height="250"
                        border
                        stripe
                        style="width: 100%;margin: 20px 0">
                    <el-table-column
                            prop="dealer_sn"
                            label="经销商编号"
                            width="120"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="dealer_name"
                            width="180"
                            label="经销商名称"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="level_name"
                            label="经销商级别"
                            width="180"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="mobile"
                            label="手机号"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="person"
                            label="负责人"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop=""
                            label="操作"
                            width="180"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="chooseDealer(scope.row)">选择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :current-page="pageNo1"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize1"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize1">
                </el-pagination>
            </el-tab-pane>
            <el-tab-pane label="选择门店" name="second">
                <el-form ref="form1" :model="form1" label-width="100px" :inline="true" class="mt20">
                    <el-form-item label="门店编号:">
                        <el-input v-model="form1.shop_sn" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="门店名称:">
                        <el-input v-model="form1.shop_name" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="类型:">
                        <el-select clearable v-model="form1.isself" size="small">
                            <el-option v-for=" i in storeArr" :key="i.id" :label="i.label"
                                       :value="i.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="关键词:">
                        <el-input v-model="form1.keywords" clearable placeholder="手机号,负责人"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getStore()">搜索</el-button>
                    </el-form-item>
                </el-form>
                <span>提示：门店资料请【客户】-【门店管理】中添加、管理，发货给门店只能选择直属总部的门店.</span>
                <!--表格-->
                <el-table
                        ref="multipleTable"
                        :data="tableData2"
                        v-loading="loading"
                        height="250"
                        border
                        style="width: 100%;margin: 20px 0">
                    <el-table-column
                            prop="shop_sn"
                            label="门店编号"
                            width="120"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="shop_name"
                            width="180"
                            label="门店名称"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="address"
                            label="门店地址"
                            width="180"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="mobile"
                            label="手机号"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="person"
                            label="负责人"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop="isself"
                            label="类型"
                            show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column
                            prop=""
                            label="操作"
                            width="180"
                            show-overflow-tooltip>
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="chooseStore(scope.row)">选择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!--分页-->
                <el-pagination
                        style="margin: 20px 0"
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :current-page="pageNo2"
                        :page-sizes="[20, 50, 100, 200]"
                        :page-size="pageSize2"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalSize2">
                </el-pagination>
            </el-tab-pane>
        </el-tabs>

        <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="handleClose">确 定</el-button>
  </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "selectRole",
        data() {
            return {
                loading:false,
                activeName2: 'first',
                form: {
                    dealer_sn:'',
                    dealer_name:'',
                    keywords:''
                },
                form1: {
                    shop_name:'',
                    shop_sn:'',
                    isself:'',
                    keywords:''
                },
                storeArr:[
                    {
                        label:'全部',
                        id:'',
                    },
                    {
                        label:'直营门店',
                        id:1,
                    },
                    {
                        label:'非直营门店',
                        id:2,
                    }
                ],//门店类型
                tableData1: [],
                tableData2: [],
                multipleSelection: [],
                //经销商分页
                pageNo1: 1,//页码
                pageSize1: 20,//每页现实的条数
                totalSize1: 0,//总条数
                //门店分页
                pageNo2: 1,//页码
                pageSize2: 20,//每页现实的条数
                totalSize2: 0,//总条数
            }
        },
        methods: {
            //查询经销商
            getDealer(){
                this.loading = true;
                this.$get('logistics','/dealers', {
                    per_page:this.pageSize1,
                    page:this.pageNo1,
                    dealer_sn:this.form.dealer_sn,
                    is_parent:1,
                    dealer_name:this.form.dealer_name,
                    keywords:this.form.keywords
                }).then(res => {
                    this.loading = false;
                    this.tableData1 = res.data;
                    this.totalSize1 = res.meta.total;
                }).catch(function (error) {
                    this.loading = false;
                    console.log(error);
                });
            },
            //选择经销商
            chooseDealer(row){
                this.$emit('pushData',row);
                this.$emit('handleClose');
            },
            //选择门店
            chooseStore(row){
                this.$emit('pushData',row);
                this.$emit('handleClose');
            },
            //查询门店
            getStore(){
                this.loading = true;
                this.$get('logistics','/shops', {
                    per_page:this.pageSize2,
                    page:this.pageNo2,
                    shop_sn:this.form1.shop_sn,
                    shop_name:this.form1.shop_name,
                    is_parent:1,
                    isself:'',
                    keywords:this.form1.keywords
                }).then(res => {
                    this.loading = false;
                    this.tableData2 = res.data;
                    this.totalSize2 = res.meta.total;
                }).catch(function (error) {
                    this.loading = false;
                    console.log(error);
                });

            },
            handleClick(tab, event) {
                //console.log(tab, event);
            },
            /*分页*/
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.pageNo1 = 1;
                this.getDealer();
            },
            handleCurrentChange1(val) {
                this.pageNo1 = val;
                this.getDealer();
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.pageNo2 = 1;
                this.getStore();
            },
            handleCurrentChange2(val) {
                this.pageNo2 = val;
                this.getStore();
            },
            handleClose() {
                this.$emit('handleClose');
            }

        },
        created() {
            this.getDealer();
            this.getStore();

        }
    }
</script>

<style lang="scss" scoped>

</style>